import cx from 'classnames'

import { PRODUCT_TOUR_URL } from 'utils/constants'
import { ReactComponent as Play } from 'assets/icons/play32.svg'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ReactComponent as Chevron } from 'assets/icons/chevronRight24.svg'
import productTour from './productTour.png'
import Styles from './LinkCards.module.scss'

export const ProductTourCard = () => {
  const { isTabletPortrait } = useResponsiveDesign()

  return (
    <a href={PRODUCT_TOUR_URL} target="_blank" rel="noreferrer" className={Styles.option}>
      <div className={cx(Styles.left, { [Styles.mobile]: isTabletPortrait, [Styles.blue]: isTabletPortrait })}>
        {isTabletPortrait ? <Play /> : <img src={productTour} alt="View Product Tour" />}
      </div>
      <div className={Styles.right}>
        <div className={Styles.optionTitle}>Almanac Product Tour</div>
        <div className={Styles.optionSubtitle}>Watch 5 minute demo of how Almanac works</div>
      </div>
      <div className={Styles.chevronContainer}>
        <Chevron />
      </div>
    </a>
  )
}
